import React from 'react';
import { AnnouncementBar } from '../components/sections/AnnouncementBar';
import { HeroBannerSlider } from '../components/sections/HeroBannerSlider';
import { Hero } from '../components/sections/Hero';
import { SolutionsSection } from '../components/sections/SolutionsSection';
import { ProcessSection } from '../components/sections/ProcessSection';
import { TechnologySection } from '../components/sections/TechnologySection';
import { KitSection } from '../components/sections/KitSection';
import { PlansSection } from '../components/sections/PlansSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { FAQSection } from '../components/sections/FAQSection';
import { FinalCTA } from '../components/sections/FinalCTA';
import { ContactSection } from '../components/sections/ContactSection';
export type HomeView = 'landing' | 'faq';
interface HomePageProps {
  view: HomeView;
  onBack: () => void;
  onCTA: (id: string) => void;
}
export function HomePage({
  view,
  onBack,
  onCTA
}: HomePageProps) {
  if (view === 'faq') {
    return <main data-id="element-892" data-mp="2eqgq58m1uyil">
        <FAQSection onBack={onBack} data-id="element-893" data-mp="2eq8cvfm0lr6v" />
      </main>;
  }
  return <main data-id="element-894" data-mp="2eodsc2eno13b">
      <AnnouncementBar data-id="element-895" data-mp="2jh6uciiqovbp" />
      <HeroBannerSlider data-id="element-896" data-mp="2jgorh31kniut" />
      <Hero onCTA={onCTA} data-id="element-897" data-mp="2jihvsboppqzn" />
      <SolutionsSection onCTA={onCTA} data-id="element-898" data-mp="2jj9tpt5s80t3" />
      <ProcessSection onCTA={onCTA} data-id="element-899" data-mp="2ogt5mmf0c1hv" />
      <TechnologySection data-id="element-900" data-mp="2ofrvql9q9l1q" />
      <KitSection onCTA={onCTA} data-id="element-901" data-mp="2oi4ayqo3phb3" />
      <PlansSection data-id="element-902" data-mp="1rqis135bxjwg" />
      <TestimonialsSection data-id="element-903" data-mp="1rr2aqm2t0cbj" />
      <FinalCTA onCTA={onCTA} data-id="element-904" data-mp="1rru0hg9pzftw" />
      <ContactSection data-id="element-905" data-mp="1vrchi0yf76rg" />
    </main>;
}